import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Modal, Form, Dropdown } from "semantic-ui-react";
import { translate } from "react-i18next";

const UserModalComponent = props => (
  <Modal open={props.modalVisible} onActionClick={props.toggleModal}>
    <Modal.Header>
      {props.selected
        ? props.t("user:editUserText")
        : props.t("user:addUserButton")}
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <Form as="form" size="large" onSubmit={props.handleSubmit}>
          <Field
            name="email"
            type="email"
            label="E-mail"
            component={Form.Input}
            fluid
            placeholder="E-mail"
          />
          <Field
            name="firstname"
            type="text"
            label={props.t("user:firstnameText")}
            component={Form.Input}
            fluid
            placeholder={props.t("user:firstnameText")}
          />
          <Field
            name="surname"
            type="text"
            label={props.t("user:surnameText")}
            component={Form.Input}
            fluid
            placeholder={props.t("user:surnameText")}
          />
          {!props.selected && (
            <Field
              name="password"
              type="password"
              label={props.t("user:passwordText")}
              component={Form.Input}
              fluid
              placeholder={props.t("user:passwordText")}
            />
          )}

          {props.hotels.length > 0 && (
            <Form.Field>
              <label>{props.t("user:hotelsText")}</label>
              <Field
                name="hotelIds"
                component={({ input }) => (
                  <Dropdown
                    fluid
                    multiple
                    placeholder={props.t("user:hotelsPickerText")}
                    search
                    selection
                    onChange={(event, data) => input.onChange(data.value)}
                    value={input.value}
                    options={props.hotels.map(hotel => ({
                      value: hotel.hotelId,
                      text: hotel.hotelName
                    }))}
                  />
                )}
              />
            </Form.Field>
          )}
          <Button color="blue" type="submit">
            {props.t("common:saveText")}
          </Button>
          <Button onClick={() => props.toggleModal()}>
            {props.t("common:cancelText")}
          </Button>
        </Form>
      </Modal.Description>
    </Modal.Content>
  </Modal>
);

export const UserModal = reduxForm({
  form: "users"
})(translate("translations")(UserModalComponent));



// WEBPACK FOOTER //
// ./src/users/UsersList/UserModal.js